// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3AgdA","inputWrap":"styles_inputWrap__2YYfC","input":"styles_input__zGlGF"};